<div
	class="sl-flexbox-column sl-flexbox-gap-24"
	[data-testid]="dialogTestIds.DialogRootElement">
	<div
		class="sl-flexbox-gap-16 sl-typography-body {{ mergedData.contentStyleClass }}"
		[data-testid]="dialogTestIds.DialogContentElement"
		[innerHTML]="mergedData.content"></div>
	<div class="sl-horizontal-break"></div>
	<div class="sl-flexbox sl-flexbox-gap-16 sl-flexbox-justify-end">
		@if (mergedData.showCancelButton && mergedData.cancelButtonCaption?.length) {
			<sl-text-button
				[data-testid]="dialogTestIds.CancelButton"
				[label]="mergedData.cancelButtonCaption"
				(onClick)="closeDialog(false)"></sl-text-button>
		}
		<sl-button
			[data-testid]="dialogTestIds.ConfirmationButton"
			[label]="mergedData.confirmButtonCaption"
			[severity]="mergedData.confirmButtonTheme"
			(onClick)="closeDialog(true)"></sl-button>
	</div>
</div>
